import { render, staticRenderFns } from "./PrivacyPolicyComponent.vue?vue&type=template&id=19322916&scoped=true"
import script from "./PrivacyPolicyComponent.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyComponent.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicyComponent.vue?vue&type=style&index=0&id=19322916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19322916",
  null
  
)

export default component.exports